import { Box, Text, Button, Flex, Icon, Tag, TagLabel } from "@chakra-ui/react";
import { StatusRequerimentoTag } from "components/Atomos/Tags/StatusRequerimentoTag";
import React from "react";
import { RiCalendar2Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { getSituacaoPendenciaInfo } from "utils/situacao-pendencia";
import { formatarProtocolo } from "utils/protocolo";

export const RequerimentoCard: React.FC<{
  id: string;
  title: string;
  data: string;
  protocolo: string;
  status?: {
    value: number;
    name: string;
  };
  /** Pendências do cidadão ainda não resolvidas. Sem valor ou 0, nada é exibido. */
  quantidadePendencias?: number;
  /** Situação da pendência mais relevante — define a cor, o ícone e o texto. */
  situacaoPendencia?: string | null;
}> = ({
  id,
  title,
  data,
  protocolo,
  status,
  quantidadePendencias,
  situacaoPendencia
}) => {
  const navigate = useNavigate();

  // O status do requerimento diz em que etapa ele está; não diz que existe algo
  // esperando o cidadão. Sem este aviso ele só descobre a pendência abrindo o
  // detalhe, um por um.
  const temPendencia = !!quantidadePendencias && quantidadePendencias > 0;
  const infoPendencia = getSituacaoPendenciaInfo(situacaoPendencia);
  const plural = quantidadePendencias === 1 ? "pendência" : "pendências";
  const textoPendencia =
    situacaoPendencia === "INFORMACAO_RECEBIDA"
      ? `${quantidadePendencias} ${plural} aguardando análise`
      : `Há ${quantidadePendencias} ${plural} em aberto`;

  return (
    <Box>
      <Flex mb="1" gap="2" wrap="wrap">
        <Flex
          borderStyle="solid"
          borderWidth={1}
          borderColor="gray.400"
          borderRadius="md"
          px="2"
          fontSize="xs"
          alignItems="center"
        >
          Protocolo: {formatarProtocolo(protocolo)}
        </Flex>
        {status && (
          <StatusRequerimentoTag
            id={status.value.toString()}
            nome={status.name}
          />
        )}
        {temPendencia && (
          <Tag size="sm" colorScheme={infoPendencia.colorScheme}>
            <Icon as={infoPendencia.icon} mr="1" aria-hidden />
            <TagLabel>{textoPendencia}</TagLabel>
          </Tag>
        )}
      </Flex>
      <Text fontWeight="medium">{title}</Text>
      <Flex alignItems="center" gap={1} fontSize="sm" mt="0.5">
        <RiCalendar2Line /> Data de solicitação:{" "}
        <Text as="span" fontWeight="medium">
          {data}
        </Text>
      </Flex>
      <Button
        variant="mainOutline"
        size="sm"
        mt="2"
        onClick={() => navigate(`/licenciamento-urbano/requerimento/${id}`)}
      >
        Acompanhar solicitação
      </Button>
    </Box>
  );
};
